import React from 'react';
import { BRAND, isBrandOV, isMarketGB } from '../../../constants/main';
import { TrimTitleSectionStyledOVGB } from '@components/v2/TrimTitleSection/OV/GB/TrimTitleSectionStyled.OVGB';
import { TrimTitleSectionStyledOV } from '@components/v2/TrimTitleSection/OV/TrimTitleSectionStyled.OV';
import { TrimTitleSectionStyledAC } from '@components/v2/TrimTitleSection/AC/TrimTitleSectionStyled.AC';
import { TrimTitleSectionStyledAP } from '@components/v2/TrimTitleSection/AP/TrimTitleSectionStyled.AP';
import { TrimTitleSectionStyledDS } from '@components/v2/TrimTitleSection/DS/TrimTitleSectionStyled.DS';
import { TrimTitleSectionStyled } from '@components/v2/TrimTitleSection/TrimTitleSectionStyled';
import { SC } from '../../../styles/theme';

export interface TrimTitleSectionProps extends SC {
    openFilter: any;
    onClickCTAFilters?: (label: string) => void;
}

const TrimTitleSection = (props: TrimTitleSectionProps) => {
    if (isBrandOV)
        return isMarketGB ? <TrimTitleSectionStyledOVGB {...props} /> : <TrimTitleSectionStyledOV {...props} />;
    if (BRAND === 'AC') return <TrimTitleSectionStyledAC {...props} />;
    if (BRAND === 'AP') return <TrimTitleSectionStyledAP {...props} />;
    if (BRAND === 'DS') return <TrimTitleSectionStyledDS {...props} />;
    return <TrimTitleSectionStyled {...props} />;
};

export default TrimTitleSection;
